import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check } from 'lucide-react';
import { Carousel } from './Carousel';
const volumesData = [{
  id: 1,
  title: 'Cumpleaños Infantiles Temáticos',
  icon: '🎂',
  quote: 'El evento con el que empezó todo — y el que más te van a pedir.',
  bullets: ['Paso a paso para 8 temáticas infantiles más pedidas', 'Cómo armar la mesa dulce sin gastar de más', 'Combinación de colores y globos por temática', 'Presupuesto tipo para cumpleaños infantil completo', 'Errores más comunes que hacen que "no cierre" la estética'],
  images: ['https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1558636508-e0db3814bd1d?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1607344645866-009c320b63e0?auto=format&fit=crop&q=80&w=600']
}, {
  id: 2,
  title: 'Mesversarios y Baby Showers',
  icon: '🍼',
  quote: 'El nicho que menos competencia tiene y más rápido crece.',
  bullets: ['Decoración de mesversario mes a mes', 'Baby shower: revelación de género, temáticas y paletas', 'Cómo armar candy bar y mesa de dulces a juego', 'Presupuesto para baby shower completo', 'Ideas para fotos que generan boca en boca'],
  images: ['https://images.unsplash.com/photo-1522771930-78848d9293e8?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1481349518771-20055b2a7b24?auto=format&fit=crop&q=80&w=600']
}, {
  id: 3,
  title: 'XV / Sweet 16',
  icon: '👑',
  quote: 'El evento con más presupuesto y donde más se puede cobrar.',
  bullets: ['Decoración de salón completa por estilo (clásico, boho, glam)', 'Photo corner y ambientación por sector', 'Iluminación: cómo transformar cualquier salón', 'Presupuesto tipo para XV según tamaño de evento', 'Cómo presentar tu propuesta a la familia sin quedar cara'],
  images: ['https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?auto=format&fit=crop&q=80&w=600']
}, {
  id: 4,
  title: 'Casamientos Económicos e Íntimos',
  icon: '💍',
  quote: 'La tendencia que más creció — bodas chicas, con mucho estilo.',
  bullets: ['Decoración para casamientos de menos de 50 invitados', 'Cómo lograr un look "boda cara" con presupuesto ajustado', 'Centros de mesa y arcos florales low cost', 'Presupuesto tipo para casamiento íntimo', 'Cómo coordinar con otros proveedores (catering, música)'],
  images: ['https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&q=80&w=600']
}, {
  id: 5,
  title: 'Eventos Corporativos e Inauguraciones',
  icon: '🏢',
  quote: 'El evento que paga mejor y casi nadie ofrece.',
  bullets: ['Decoración para inauguraciones de locales y oficinas', 'Ambientación para lanzamientos de producto chicos', 'Cómo cotizar un evento corporativo (tarifas distintas)', 'Presupuesto tipo para evento corporativo chico', 'Cómo conseguir tu primer cliente corporativo'],
  images: ['https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?auto=format&fit=crop&q=80&w=600']
}, {
  id: 6,
  title: 'Fiestas Temáticas de Adultos',
  icon: '🥂',
  quote: 'Despedidas, cumpleaños de 30/40/50 — el segmento que más gasta.',
  bullets: ['Decoración para despedidas de soltera/o por estilo', 'Cumpleaños de adultos: temáticas elegantes vs. divertidas', 'Barra de tragos y rincón de fotos', 'Presupuesto tipo para fiesta de adultos', 'Cómo upsellear servicios extra (candy bar, DJ, catering)'],
  images: ['https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=600']
}];
export function Volumes() {
  const [openId, setOpenId] = useState<number | null>(1);
  return <section id="volumes" className="py-16 px-5 bg-wine text-white" data-id="element-247">
      <div className="max-w-md mx-auto" data-id="element-248">
        <div className="flex justify-center mb-4" data-id="element-249">
          <span className="bg-gold/20 text-gold border border-gold/30 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-250">
            🎁 Sistema Completo
          </span>
        </div>
        <h2 className="text-3xl font-bold text-center mb-3" data-id="element-251">
          6 tomos. Todo tipo de evento. Todo resuelto.
        </h2>
        <p className="text-center text-white/80 mb-10 text-[15px]" data-id="element-252">
          De decoradora de onda a experta que cobra por su trabajo.
        </p>

        <div className="flex flex-col gap-3" data-id="element-253">
          {volumesData.map(vol => <div key={vol.id} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden" data-id="element-254">
              <button onClick={() => setOpenId(openId === vol.id ? null : vol.id)} className="w-full p-4 flex items-center justify-between text-left active:bg-white/5 transition-colors" data-id="element-255">
                <div className="flex items-center gap-3" data-id="element-256">
                  <span className="text-gold font-bold text-lg w-5" data-id="element-257">
                    {vol.id}
                  </span>
                  <span className="text-xl" data-id="element-258">{vol.icon}</span>
                  <span className="font-bold text-[15px] pr-2" data-id="element-259">
                    {vol.title}
                  </span>
                </div>
                <ChevronDown className={`w-5 h-5 text-white/50 shrink-0 transition-transform duration-300 ${openId === vol.id ? 'rotate-180' : ''}`} data-id="element-260" />
              </button>

              <AnimatePresence initial={false} data-id="element-261">
                {openId === vol.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-262">
                    <div className="p-4 pt-0 border-t border-white/10 mt-2" data-id="element-263">
                      <p className="italic text-white/70 text-sm mb-4 mt-4" data-id="element-264">
                        "{vol.quote}"
                      </p>

                      <ul className="space-y-2 mb-6" data-id="element-265">
                        {vol.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-266">
                            <Check className="w-4 h-4 text-pink-pastel shrink-0 mt-0.5" data-id="element-267" />
                            <span className="text-white/90" data-id="element-268">{bullet}</span>
                          </li>)}
                      </ul>

                      {/* Carousel inside accordion */}
                      <div className="w-full relative -mx-4 px-4" data-id="element-269">
                        <Carousel images={vol.images.map(src => ({
                    src
                  }))} theme="light" slideWidthClass="w-[80%]" rounded="rounded-xl" data-id="element-270" />
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="mt-8 bg-white/10 rounded-xl p-5 border border-white/20" data-id="element-271">
          <h4 className="font-bold text-gold mb-3 text-sm uppercase tracking-wider" data-id="element-272">
            Cada tomo incluye:
          </h4>
          <ul className="grid grid-cols-1 gap-2 text-sm text-white/90" data-id="element-273">
            <li className="flex items-center gap-2" data-id="element-274">
              <Check className="w-4 h-4 text-gold" data-id="element-275" /> Fotos de referencia en
              alta calidad
            </li>
            <li className="flex items-center gap-2" data-id="element-276">
              <Check className="w-4 h-4 text-gold" data-id="element-277" /> Presupuesto editable por
              tipo de evento
            </li>
            <li className="flex items-center gap-2" data-id="element-278">
              <Check className="w-4 h-4 text-gold" data-id="element-279" /> Paleta de colores sugerida
            </li>
            <li className="flex items-center gap-2" data-id="element-280">
              <Check className="w-4 h-4 text-gold" data-id="element-281" /> Checklist de armado paso a
              paso
            </li>
            <li className="flex items-center gap-2" data-id="element-282">
              <Check className="w-4 h-4 text-gold" data-id="element-283" /> 100% pensado para el
              mercado argentino 2026
            </li>
          </ul>
        </div>
      </div>
    </section>;
}